import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import App from './App.vue'
import router from './router'
import './components/navTab/index.js'
// import '@@c/vue/components/index.js'
import '@/assets/css/normalize.css'
import '@/assets/css/global.css'
import '@/assets/css/flex.scss'
import '@/assets/css/rc-cascade.scss'
import '@/assets/css/spacing.scss'
import '@/assets/css/text.scss'
import '@/assets/css/common.scss'
import '@/assets/css/kmtIconfont.scss'
import '@/assets/css/erpTrade.scss'
import store from './store'
import {preInit} from './pre-init.js';

import { install } from '@/assets/js/index.js';
import '@/assets/css/index.css';
import '@/assets/css/shopSource.scss';
import vPermission from '@/directives/directive.permission.js';
import vStickyTableHeader from '@/directives/sticky-table-header.js';
import vClickExclude from '@/directives/click-exclude.js';
import { getAjax, postAjax } from '@api/trade/index.js';
import AmountDigitInput from '@/components/common/AmountDigitInput.vue';
import AmountDigitText from '@/components/common/AmountDigitText.vue';

// 目前支持的主题
// 1. 极客蓝 #2695FA 默认主题
// 2. 大b端 #5d86f5
// 3. 小b端 #2695FA
// 随机颜色值也支持（暂时不使用，有些组件颜色值的细节会有偏差，待调整）
install(Vue);
Vue.prototype.$change_color(/* 参数为颜色16进制值 默认为 #2695FA */);

Vue.use(VueClipboard)
Vue.use(VueVirtualScroller)
Vue.config.productionTip = false

// 拦截 Vue 运行时错误，只输出到控制台，不在页面显示覆盖层
if (process.env.NODE_ENV !== 'production') {
  Vue.config.errorHandler = function (err) {
    console.error(err);
  };
}
Vue.directive('click-exclude', vClickExclude);
Vue.directive('permission', vPermission);
Vue.directive('sticky-table-header', vStickyTableHeader);
Vue.prototype.$puhuoDialog = null
Vue.prototype.$fromGyl = null
Vue.prototype.$bus = new Vue();

preInit()

// register web worker
let webWorker;
if (window.Worker)  {
  webWorker = (data) => {
    return new Promise((resolve) => {
      const worker = new Worker('/webworker.js');
      worker.postMessage({ type: 'fetch', data });
      worker.onmessage = (event) => {
        resolve(event.data);
        worker.terminate();
      };
      worker.onerror = () => {
        resolve('WorkerError');
      };
    });
  };
}
Vue.prototype.$worker = webWorker;
Vue.prototype.$erpApi = {
  get: getAjax,
  post: postAjax
};

// 注册全局组件
Vue.component('AmountDigitInput', AmountDigitInput);
Vue.component('AmountDigitText', AmountDigitText);

window._globel_vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

